import styled from 'styled-components';

export const Container = styled.div`
  height: 100vh;
  width: 100vw;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #000000;

  .content {
    max-width: 1024px;

    .header-help {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 40px;

      img {
        object-fit: contain;
        height: 60px;
        border-right: 1px solid #fff;
        margin-right: 40px;
        padding-right: 40px;
      }

      .welcome {
        h2 {
          margin: 0;
          color: #808080;
        }

        h1 {
          font-size: 4rem;
          margin: 0;
          color: #fff;
        }
      }
    }

    > h1 {
      color: #fff;
      font-size: 2.7rem;
      text-align: center;
      line-height: 3rem;
    }
  }
`;
